import React, { Component } from 'react';
import { ArrowRight, Share } from 'react-bootstrap-icons';
import positions from '../databases/careers_db';
import TopNav from '../components/top_nav';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../components/footer';

const JobDescriptionScreen = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    console.log(id);
    const job = positions.find(p => p.id === Number(id));

    if (!job) {
        return <div>Job not found</div>;
    }
    const remainingJobs = positions.filter(p => p.id !== Number(id));


    return (
        <div className='row mx-0 justify-content-center'>
            <TopNav />
            <div className='col-md-11 px-4'>
                <div className='row'>
                    <div className="my-4 pt-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="btn btn-link px-0 d-flex align-items-center gap-2 fs-18 text-black text-decoration-none">
                            <i className="bi bi-chevron-left text-primary-blue fw-bold"></i>Back to Careers
                        </button>
                    </div>

                    <div className="">
                        <div className="d-flex justify-content-between align-items-start mb-4">
                            <div className='w-60'>
                                <h4 className="fw-bold mb-2 fs-32">
                                    {job.title}
                                </h4>
                            </div>
                            <div className="d-flex gap-2 ps-0">
                                <button
                                    onClick={() => navigate(`/job-apply-form/${job.id}`)}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                                >
                                    <span className="mx-3 fs-14">Apply now</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{ width: '32px', height: '32px', backgroundColor: '#ffffff' }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                                <button
                                    onClick={() => window.location.href = "job-description"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-primary-blue bg-white border-primary-blue"
                                >
                                    <span className="mx-3 fs-14">Share Opportunity</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle bg-primary-blue"
                                        style={{ width: '32px', height: '32px' }}
                                    >
                                        <Share color="#ffffff" className='fs-12 fw-bold' />
                                    </div>
                                </button>
                            </div>
                        </div>

                        <div className='mb-3'>
                            <p className="text-primary-blue w-90">
                                {job.summary}
                            </p>
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-6 d-flex flex-column gap-1">
                                <div className='text-primary-blue'><strong>Location:</strong> {job.location}</div>
                                <div className='text-primary-blue'><strong>Role:</strong> {job.type}</div>
                                <div className='text-primary-blue'><strong>Experience:</strong> {job.experience}</div>
                                <div className='text-primary-blue'><strong>Industry:</strong> {job.industry}</div>
                                <div className='text-primary-blue'><strong>Department:</strong> {job.department}</div>
                            </div>
                        </div>

                        <hr />

                        <div className="row px-3">
                            <div className="col-md-7 d-flex flex-column gap-4">
                                <div>
                                    <label className='fs-24 text-primary-blue mb-3'>Job Description</label>
                                    <h6 className="fw-bold mb-2">Key Responsibilities</h6>
                                    <ul className="mb-0">
                                        {job.responsibilities.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div>
                                    <h6 className="fw-bold mb-2">Good to Have</h6>
                                    <ul className="mb-0">
                                        {job.goodToHave.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div>
                                    <h6 className="fw-bold mb-2">What We Offer</h6>
                                    <ul className="mb-0">
                                        {job.whatWeOffer.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="col-md-5 d-flex flex-column gap-4 border-start ps-md-5">
                                <div>
                                    <label className="fs-24 text-primary-blue mb-3">Required Qualifications</label>
                                    <ul className="mb-0">
                                        {job.qualifications.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div>
                                    <div><strong className='text-primary-blue'>Deadline to Apply:</strong> {job.deadline}</div>
                                    <div><strong className='text-primary-blue'>Expected Joining:</strong> {job.joining}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mx-md-4 py-5 mt-5">
                        <div className="text-center mb-4">
                            <h6 className="text-muted">Current Openings</h6>
                            <h2 className="fw-bold fs-36">Explore Open Positions</h2>
                        </div>

                        <div className="row mt-5">
                            {remainingJobs.map((job, index) => (
                                <div className="col-md-4 mb-4" key={index}>
                                    <div className="  rounded-4 p-4 h-100 shadow-sm">
                                        <div className="mb-3">
                                            <span className="badge   text-dark border me-2 px-3 py-1 rounded-pill fs-14">
                                                {job.type}
                                            </span>
                                            <span className="badge   text-dark border px-3 py-1 rounded-pill fs-14">
                                                {job.location}
                                            </span>
                                        </div>
                                        <h5 className="fs-18 fw-bold">{job.title}</h5>
                                        <p className="fs-14">{job.description}</p>
                                        <button
                                            onClick={() => navigate(`/job-description/${job.id}`)}
                                            className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-3 bg-primary-blue"
                                        >
                                            <span className="mx-3 fs-14">View full job description</span>
                                            <div
                                                className="d-flex justify-content-center align-items-center rounded-circle"
                                                style={{ width: '35px', height: '35px', backgroundColor: '#ffffff' }}
                                            >
                                                <ArrowRight color="#193E6C" />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="mx-md-4 mb-5">
                        <div className="  rounded-4 p-4 shadow-sm">
                            <h6 className="text-primary-blue fw-semibold mb-2 fs-20">
                                Can’t Find a Role That Fits?
                            </h6>
                            <h2 className="fw-bold mb-3">We’d still love to hear from you.</h2>
                            <p className="mb-4 fs-18">
                                We’re always open to meeting great minds. If you’re passionate about
                                what we do and believe you can bring value to the future of rail
                                technology, don’t wait for a listing.
                            </p>
                            <button
                                onClick={() => window.location.href = "about"}
                                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-3 bg-primary-blue"
                            >
                                <span className="mx-3 fs-14">Apply now</span>
                                <div
                                    className="d-flex justify-content-center align-items-center rounded-circle"
                                    style={{ width: '35px', height: '35px', backgroundColor: '#ffffff' }}
                                >
                                    <ArrowRight color="#193E6C" />
                                </div>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <Footer/>
        </div>
    );
}



export default JobDescriptionScreen;

